import { DialogSimple } from '@/components/DialogSimple'
import { useUiStore, useUiStoreActions } from '@/stores/ui'

export const CallEndDialog = () => {
  const callEndDialogDescription = useUiStore(
    state => state.callEndDialogDescription,
  )
  const callEndDialogOnConfirm = useUiStore(
    state => state.callEndDialogOnConfirm,
  )
  const displayCallEndDialog = useUiStore(state => state.displayCallEndDialog)
  const { hideCallEndDialog, setCallEndDialogContent } = useUiStoreActions()

  const handleConfirm = () => {
    callEndDialogOnConfirm?.()
    hideCallEndDialog()
    setCallEndDialogContent({
      description: '',
      onConfirm: undefined,
    })
  }

  return (
    <DialogSimple
      open={displayCallEndDialog}
      tag="phone-disabled"
      confirmLabel="OK"
      onConfirm={handleConfirm}
      dialogDescription={callEndDialogDescription}
      dialogTitle="Call Ended"
    />
  )
}
